import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useSupabaseClient } from '#imports'

export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const supabase = useSupabaseClient()

    // Get the session token from Supabase
    const { data: session } = await supabase.auth.getSession()
    const token = session?.session?.access_token

    if (!token) {
      console.warn('No session token found, redirecting to login...')
      return navigateTo('/login')
    }

    /* console.log('🔹 Sending token to API:', token) */

    // Fetch user with explicit Authorization header
    const response = await $fetch('/api/auth/user', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}` // ✅ Send token manually
      },
      credentials: 'include'
    })

    if (!response?.user) {
      console.warn('No user found, redirecting to unauthorized...')
      return navigateTo('/unauthorized')
    }

    const allowedUserId = '1e373897-f9a3-4cd3-a729-e982ef08f7fe' // Replace with actual ID
    /* console.log(`Checking User ID: ${response.user.id} === ${allowedUserId}`) */

    if (response.user.id !== allowedUserId) {
      console.warn(`User ${response.user.id} is not authorized. Redirecting...`)
      return navigateTo('/unauthorized')
    }

    /* console.log('✅ Access granted to:', response.user.id) */
  } catch (error) {
    console.error('❌ Error in restrict-user middleware:', error)
    return navigateTo('/unauthorized')
  }
})
